import classNames from 'classnames';
import React, { ReactElement } from 'react';
import './ButtonList.scss';
import IButtonListProps from './ButtonListProps';

function ButtonList<T>({ onChange, type = 'default', value, children, className }: IButtonListProps<T>) {
  const classes = classNames('button-list', { 'vertical-nav': type === 'nav' }, className);

  function handleChange(v: T, onClick: (event: MouseEvent) => void, event: MouseEvent) {
    if (onChange) {
      onChange(v);
    }

    if (onClick) {
      onClick(event);
    }
  }

  function renderChildren() {
    return React.Children.map(
      children as Array<
        ReactElement & { type: { name: string }; props: { value: string; onClick: (event: React.MouseEvent) => void } }
      >,
      (child, index) => {
        if (child?.type?.name === 'Button') {
          const onClick = (event: MouseEvent) => handleChange(child.props.value, child.props.onClick, event);
          return React.cloneElement(child, {
            key: index,
            onClick,
            className: value !== undefined && child.props.value === value ? 'active' : null,
          });
        } else {
          return child;
        }
      }
    );
  }

  return <div className={classes}>{renderChildren()}</div>;
}

export default ButtonList;
